(function() {
  function addColorSwatches() {
    const iconMap = {
      'gold-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Gold-Stripes.svg?v=1768268558',
      'teal-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Teal-Stripes.svg?v=1768268558',
      'green-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Green-Stripes.svg?v=1768268558',
      'blue-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Blue-Stripes.svg?v=1768268558',
      'pink-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Pink-Stripes.svg?v=1768268558',
      'yellow-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Yellow-Stripes.svg?v=1768268558',
      'purple-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Purple-Stripes.svg?v=1768268558',
      'beige-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Beige-Stripes.svg?v=1768268891',
      'grey-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Grey-Stripes.svg?v=1768268558',
      'black-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Black-Stripes.svg?v=1768268558',
      'brown-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Brown-Stripes.svg?v=1768268558',
      'orange-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Orange-Stripes.svg?v=1768268558',
      'red-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Red-Stripes.svg?v=1768268558',
      'white-striped': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/White-Stripes.svg?v=1768268558',
      'black-and-white-striped-wallpaper': 'https://cdn.shopify.com/s/files/1/0725/8351/2286/files/Black-White-Stripes.svg'
    };

    Object.keys(iconMap).forEach(function(color) {
      const links = document.querySelectorAll('a[href*="/' + color + '"]');
      links.forEach(function(link) {
        if (!link.querySelector('.color-swatch-icon')) {
          const icon = document.createElement('img');
          icon.src = iconMap[color];
          icon.className = 'color-swatch-icon';
          icon.style.width = '20px';
          icon.style.height = '20px';
          icon.style.marginRight = '8px';
          icon.style.verticalAlign = 'middle';
          icon.style.display = 'inline-block';
          link.insertBefore(icon, link.firstChild);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addColorSwatches);
})();
